import { RECEIVE_CALLUS_ERROR } from '../constants/ActionTypes';

const initialState = {
  isError: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CALLUS_ERROR:
      return { ...state, isError: action.payload ? !action.payload : true };
    default:
      return state;
  }
}
